import React from 'react';
import Head from 'next/head';
import httpStatus from 'http-status';
import { get } from 'lodash';

import { NotFound } from '@zapier/common-components';
import errorPage from 'web-ssr/browser/pages/errorPage';

import { SsrUniversalLayout } from 'web-ssr/app/universal-layout/SsrUniversalLayout';

class ErrorPage extends React.Component {
  render() {
    const { err, statusCode } = this.props;

    const titlePrefix = (statusCode && `${statusCode}: `) || '';
    const titlePostfix =
      get(err, 'message') ||
      httpStatus[statusCode] ||
      'An unexpected error has occurred';
    const title = `${titlePrefix} ${titlePostfix}`;

    return (
      <SsrUniversalLayout>
        <Head>
          <title>{title}</title>
        </Head>
        <NotFound errorMessage={title} />
      </SsrUniversalLayout>
    );
  }
}

export default errorPage(ErrorPage);
